export const getAccessTokenFromStorage = (key: string): string | null => {
  try {
    if (globalThis.window === undefined) return null;
    return sessionStorage.getItem(key);
  } catch (_: unknown) {
    return null;
  }
};
